const doc = [({"no":({"js":({"user":({"school_classes":({"digital_class_room":({"insights":"Innsikt", "name_your_class":"Gi klassen et navn"})})})})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;